import { createAxiosInstance } from '@servicetitan/cp-api';
import { injectable, inject, optional } from '@servicetitan/react-ioc';
import { LegalAgreementClient } from './user-client';

@injectable()
export class LegalAgreementApi {
    client: LegalAgreementClient;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.client = new LegalAgreementClient(baseUrl, createAxiosInstance());
    }
}
